import { gql } from '@apollo/client';

const accessFragment = gql`
  fragment Access on Employer {
    id
    initials
    name
    email
    accessType
    accessId
  }
`;

export default accessFragment;
